import type { HybrisUserInfo } from '../../models/hybris/hybrisUserInfo';

import { SessionStorageFacade } from '../../../../facades/storage/sessionStorageFacade';

const USER_INFO_STORAGE_KEY = 'userInfo';
const key = (userId: string) => {
    return `${USER_INFO_STORAGE_KEY}_${userId}`;
};

const hybrisUserInfoSession = {
    setHybrisUserInfo: (userId: string, userInfo: HybrisUserInfo) => {
        SessionStorageFacade.instance.addObject(key(userId), userInfo);
    },
    getHybrisUserInfo: (userId: string) =>
        SessionStorageFacade.instance.getObject<HybrisUserInfo>(key(userId)),
};

export default hybrisUserInfoSession;
